export const CREATE_COMMENT_MUTATION = `
  mutation CreateComment($entityType: String!, $entityId: Int!, $userId: Int!, $content: String!, $companyId: Int!) {
    insert_comments_one(object: {
      entity_type: $entityType
      entity_id: $entityId
      user_id: $userId
      content: $content
      company_id: $companyId
    }) {
      id
      content
      entity_type
      entity_id
      user_id
      company_id
      created_at
      updated_at
      user {
        id
        first_name
        last_name
      }
    }
  }
`;

export const DELETE_COMMENT_MUTATION = `
  mutation DeleteComment($id: Int!) {
    delete_comments_by_pk(id: $id) {
      id
    }
  }
`;
